import { BaseContainerModel } from "../../base-container.model";
import { bl_crm_organization_to_address_book_contact_record_link_RowClass } from "../../../dbschema";

export class CrmOrganizationToAddressBookContactRecordLinkContainerModel extends BaseContainerModel {
	bl_crm_organization_to_address_book_contact_record_link: bl_crm_organization_to_address_book_contact_record_link_RowClass =
		new bl_crm_organization_to_address_book_contact_record_link_RowClass();
}
